import styled from 'styled-components';
import Row from '~/grid/Row';
import TeaserTile from '../../molecules/TeaserTile/TeaserTile';
import Col from '~/grid/Col';

const RowStyled = styled(Row)`
  justify-content: flex-start;
`;

/**
 * @param {CmsTeaserTilesProps} props
 * @returns {React.ReactElement} The rendered component
 */
const CmsTeaserTiles = ({ type, tiles, parentContainerType }) => {
  const gutter = 6;
  /**
   * @returns {number}
   */
  const colAmount = () => {
    if (parentContainerType !== undefined) return 6;
    if (type === 'LARGE') return 5;
    if (type === 'MEDIUM') return 3.7;
    return 3;
  };

  return (
    <RowStyled gutter={gutter}>
      {tiles.map((tile, idx) => (
        <Col
          key={idx}
          gutter={gutter}
          colAmount={{
            xl: colAmount(),
            lg: colAmount(),
            md: 6,
            sm: 6,
            xs: 12,
          }}
        >
          <TeaserTile
            {...tile}
            type={type}
            parentContainerType={parentContainerType}
          />
        </Col>
      ))}
    </RowStyled>
  );
};

export default CmsTeaserTiles;
